import { render, staticRenderFns } from "./newsEdit.vue?vue&type=template&id=ed90f126&scoped=true&"
import script from "./newsEdit.vue?vue&type=script&lang=js&"
export * from "./newsEdit.vue?vue&type=script&lang=js&"
import style0 from "./newsEdit.vue?vue&type=style&index=0&id=ed90f126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed90f126",
  null
  
)

export default component.exports